import { render, staticRenderFns } from "./MenuButton.vue?vue&type=template&id=065a4808&"
import script from "./MenuButton.vue?vue&type=script&lang=js&"
export * from "./MenuButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports